import axios from './index'
export const getAppConfig = () => {
  return axios.get('/welldbCombine/appConfig')
}
